var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        {
          staticClass:
            "wrapper font-archivo relative text-brand-secondary overflow-x-hidden"
        },
        [
          _c("vs-header"),
          _c(
            "main",
            { attrs: { id: "content" } },
            [
              _vm.showEmailValidatedMessage
                ? _c(
                    "div",
                    {
                      staticClass:
                        "text-xl text-brand bg-brand-100 border-brand border p-1"
                    },
                    [
                      _c("div", { staticClass: "container px-1 mx-auto" }, [
                        _vm._v(
                          "Thank you! Your email address has been validated and you may now launch campaigns."
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _c(
                "keep-alive",
                { attrs: { include: "DesignerRoot" } },
                [
                  _c("router-view", {
                    key:
                      _vm.$route.name === "marketplace"
                        ? JSON.stringify(_vm.$route.query)
                        : null
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("vs-footer", { ref: "footer" }),
          _c("vs-toaster", {
            attrs: { notifications: _vm.notifications },
            on: { "remove-toast": _vm.handleRemoveNotification }
          }),
          _vm.$route.name === "sales"
            ? _c(
                "div",
                { staticClass: "csid" },
                [
                  _vm.campaign.products.length
                    ? [
                        _vm.campaign.admin_url
                          ? _c(
                              "buyer-button",
                              {
                                attrs: { small: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.navigateToAdminUrl(
                                      _vm.campaign.admin_url
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Admin for " +
                                    _vm._s(_vm.campaign.analytics_cid)
                                )
                              ]
                            )
                          : _c("small", [
                              _vm._v(_vm._s(_vm.campaign.analytics_cid))
                            ])
                      ]
                    : _vm.campaignErrorInfo
                    ? [
                        _vm.campaignErrorInfo.admin_url
                          ? _c(
                              "buyer-button",
                              {
                                attrs: { small: "small" },
                                on: {
                                  click: function($event) {
                                    return _vm.navigateToAdminUrl(
                                      _vm.campaignErrorInfo.admin_url
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "Admin for " +
                                    _vm._s(_vm.campaignErrorInfo.campaign_id)
                                )
                              ]
                            )
                          : _c("small", [
                              _vm._v(_vm._s(_vm.campaignErrorInfo.campaign_id))
                            ])
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _c("zop-im"),
          _vm.customer.is_impersonation ? _c("impersonation") : _vm._e(),
          _c("portal-target", { attrs: { name: "body" } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }